export { Icon } from './Icon';
export type { Names as IconNames } from './Icon';
